<template>
  <router-link
    :to="{ name: 'challengeDetail', params: { id: challenge.id } }"
  >
    <div class="card card-custom card-stretch gutter-b">
      <div class="card-body  text-center">
        <div class="bg-primary p-2 rounded" style="max-height: 230px; overflow: hidden;">
          
          <img
            :src="challenge.icon ? challenge.icon.uri  : '/assets/media/bipart/idea-default.svg'"
            class="align-self-center w-100"
            alt="Avatar"
          />
          
        </div>
        <div class="mt-3 text-dark font-weight-bolder text-hover-primary font-size-h5 text-left">
            {{ challenge.name }}
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "ChallengeCard",
  props: ["challenge"]
};
</script>

<style scoped></style>
